﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum odeslání podepsané smlouvy vlastníkům</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.signedSentOwnersDate" /></div>
  </div>
</fieldset>
